import ValueGeneratorInterface from "./ValueGeneratorInterface"
import ValueInterface from "../../Model/Value/ValueInterface"
import RandomNumberGenerator from "../RandomNumberGenerator"
import DivisionValue, { signs } from "../../Model/Value/DivisionValue"
import NumberValue from "../../Model/Value/NumberValue"

export default class DivisionValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(_: number, level: number): boolean {
    return level >= 2
  }

  public generate(value: number): ValueInterface {
    const divisor: number = this.randomNumberGenerator.randomInt(
      3,
      Math.round(Math.sqrt(value)),
    )

    return new DivisionValue(
      new NumberValue(divisor * value),
      this.randomNumberGenerator.pick(signs),
      new NumberValue(divisor),
    )
  }
}
